import {
  Component,
  OnInit
} from "@angular/core";
import { EstimateExternalService } from "../../master-services/estimate-external/estimate-external.service";
import { IEstimateExternal } from "../../master-models/estimate-external.model";
import { Router } from "@angular/router";
import swal from "sweetalert2";
import { NgbDateStruct } from "@ng-bootstrap/ng-bootstrap";
import { CustomerExternalService } from "../../master-services/customer-external/customer-external.service";
import { ICustomerExternal } from "../../master-models/customer-external.model";

@Component({
  selector: "app-master-estimate-customer",
  templateUrl: "./master-estimate-ext-all.component.html",
  styleUrls: [
    "./master-estimate-ext-all.component.scss",
    "../../../assets/icon/icofont/css/icofont.scss",
  ],
})
export class MasterEstimateExtAllComponent implements OnInit {
  estimates: IEstimateExternal[] = [];
  customers: ICustomerExternal[] = [];
  fromDate: NgbDateStruct;
  untilDate: NgbDateStruct;
  considerDate = false;
  selectedBusiness = null;

  constructor(
    private estimateExternalSrv: EstimateExternalService,
    private customerExtSrv: CustomerExternalService,
    private router: Router,
  ) {}

  ngOnInit() {
    this.getAllEstimates();
    this.getAllCustomersExt();
  }
  
  goToEstimateCustomerExt(id: number = null) {
    this.router.navigate(['erp/estimateCustomerExt'], {
      queryParams: { id }
    });
  }

  getEstimateTotal(estimate: IEstimateExternal): number {
    if (!estimate.details || !Array.isArray(estimate.details)) return 0;
    return estimate.details.reduce((sum, detail) => {
      const price = detail.price || 0;
      const quantity = detail.quantity || 0;
      return sum + (price * quantity);
    }, 0);
  }

  getAllEstimates() {
    let startDate = '';
    let endDate = '';

    if (this.considerDate && this.fromDate && this.untilDate) {
      startDate = `${this.fromDate.year}-${this.fromDate.month}-${this.fromDate.day}`;
      endDate = `${this.untilDate.year}-${this.untilDate.month}-${this.untilDate.day}`;
    }

    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    this.estimateExternalSrv.getEstimateExternalList(startDate, endDate, this.selectedBusiness)
      .subscribe(res => {
        this.estimates = res.data || [];
        swal.close();
      });
  }
  
  getAllCustomersExt() {
    this.customerExtSrv.getCustomerExternalList()
      .subscribe(res => {
        this.customers = res.data || [];
      });
  }

  getPDFEstimate(estimate: IEstimateExternal) {
    swal({
      title: "Obteniendo información ...",
      allowOutsideClick: false,
    });
    this.estimateExternalSrv.getEstimateExternalPDF(estimate.id)
      .subscribe({
        next: res => {
          const timestamp = new Date().getTime();
          const link = document.createElement('a');
          link.href = `${res.pdf.file}?t=${timestamp}`;
          link.download = `cotizacion-ext_${estimate.estimate_ext_consecutive}.pdf`;
          link.target = '_blank';
          link.click();
          swal.close();
        },
        error: e => {
          swal.close();
          swal({
            title: 'Error al encontrar el pdf',
            text: 'Intente nuevamente mas tarde.',
            type: 'error',
          });
        }
      });
  }

  onDateSelectionFrom(date: any) {
    if (this.untilDate) {
      const fromD = new Date(
        this.fromDate.year,
        this.fromDate.month,
        this.fromDate.day
      );
      const untilD = new Date(
        this.untilDate.year,
        this.untilDate.month,
        this.untilDate.day
      );

      if (fromD > untilD) {
        this.untilDate = this.fromDate;
      }
    }
  }

  onDateSelectionUntil(date: any) {
    const fromD = new Date(
      this.fromDate.year,
      this.fromDate.month,
      this.fromDate.day
    );
    const untilD = new Date(
      this.untilDate.year,
      this.untilDate.month,
      this.untilDate.day
    );
    if (untilD < fromD) {
      this.fromDate = this.untilDate;
    }
  }

  changeConsiderDate(event) {
    this.considerDate = !this.considerDate;
  }
}



// WEBPACK FOOTER //
// ./src/app/master/master-estimate-ext-all/master-estimate-ext-all.component.ts